
import { Config } from "../core/config"



const tiene_deuda = () => {
    return /*html*/`
                    <div class="titulo insuficiente">
                        <h2> <strong>Tenes un pago pendiente en tu suscripción</strong></h2>
                    </div>
                    <br>
                    <div class="caja-mens">
                        <h4> <strong>Gestioná tu saldo y seguí disfrutando de nuestros contenidos online.</strong> </h4>
                        <p>
                            <a href="${Config.dominioMiCuenta}/mis-pagos/pagos-pendientes" class="btn-primary" >ver pagos pendientes</a>
                        </p>
                    </div>
                    `
}

const tiene_deuda_embed = () => {
    return /*html*/`
                    <div class="titulo insuficiente">
                        <h2> <strong>Tenes un pago pendiente en tu suscripción</strong></h2>
                    </div>
                    <br>
                    <div class="caja-mens">
                        <h4> <strong>Gestioná tu saldo y seguí disfrutando de nuestros contenidos online.</strong> </h4>
                        <p>
                            <a href="${Config.dominioMiCuenta}/mis-pagos/pagos-pendientes" class="btn-primary" >ver pagos pendientes</a>
                        </p>
                    </div>
                    `
}

module.exports = { 
    tiene_deuda :tiene_deuda,
    tiene_deuda_embed: tiene_deuda_embed
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/views/tiene_deuda.js